/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import styled from "styled-components";
import styles from "~/assets/styles/Runbook.module.css";

const StyledTable = styled.table`
  width: 100%;

  thead tr {
    height: 32px;
  }

  tbody tr {
    height: 26px;
  }
`;

type Props = {
  columns: string[];
  children: React.ReactNode;
};

function SimpleTable({ columns, children }: Props) {
  return (
    <StyledTable>
      <thead>
        <tr>
          {columns.map((column) => (
            <td key={column}>
              <span className={styles.tableHeader}>{column}</span>
            </td>
          ))}
        </tr>
      </thead>

      <tbody>{children}</tbody>
    </StyledTable>
  );
}

export { SimpleTable };
